import { useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import CustomDropdown from "components/CustomDropdown";
import _EditCallModal from "components/modals/EditCallModal";
import _DeleteCampaignTargetCallModal from "components/modals/DeleteCampaignTargetCallModal";
import _CallBackUnlinkedModal from "components/modals/CallBackUnlinkedModal";
import ViewCallTranscriptDialog from "components/modals/ViewCallTranscriptDialog";
import useRequestTranscription from "hooks/useRequestTranscription";
import callConstants from "constants/Call";

const EditCallModal = withRoleCheck(_EditCallModal, [
  ACL_RELATIONSHIPS.campaignTargetCall.edit,
]);

const DeleteCampaignTargetCallModal = withRoleCheck(
  _DeleteCampaignTargetCallModal,
  [ACL_RELATIONSHIPS.campaignTargetCall.delete]
);

const CallBackUnlinkedModal = withRoleCheck(_CallBackUnlinkedModal, [
  ACL_RELATIONSHIPS.campaignTargetCall.create,
]);

const IN_PROGRESS = new Set(callConstants.TRANSCRIPT_STATUSES_IN_PROGRESS);
const WITHOUT_AFFORDANCE = new Set(
  callConstants.TRANSCRIPT_STATUSES_WITHOUT_AFFORDANCE
);

export function CallsTableActions({ original, callStatuses, invalidateData }) {
  const [transcriptOpen, setTranscriptOpen] = useState(false);
  const { mutate: requestTranscription, isPending } = useRequestTranscription({
    onAnswered: invalidateData,
  });

  const transcriptStatus = original.transcript_status;
  const readable =
    !!transcriptStatus && !WITHOUT_AFFORDANCE.has(transcriptStatus);
  const inProgress = IN_PROGRESS.has(transcriptStatus);
  // The attachment, not the Twilio metadata the recording filter also counts:
  // transcription can only act on audio that reached the bucket.
  const hasRecording = !!original.recording;
  // A request by hand overrides the rules that skipped the recording, so a
  // skipped transcript can still be asked for. A failed one is terminal.
  const canRequest =
    hasRecording &&
    (!transcriptStatus ||
      transcriptStatus === callConstants.TRANSCRIPT_STATUSES.SKIPPED);

  return (
    <>
      <CustomDropdown icon="ellipsis horizontal">
        <Dropdown.Menu direction="left">
          <EditCallModal
            call={original}
            callId={original.id}
            callStatuses={callStatuses}
            onSuccess={invalidateData}
          />
          {readable && (
            <Dropdown.Item
              disabled={inProgress}
              onClick={() => setTranscriptOpen(true)}
            >
              <Icon
                name={inProgress ? "spinner" : "file alternate"}
                loading={inProgress}
              />
              View Transcript
            </Dropdown.Item>
          )}
          {canRequest && (
            <Dropdown.Item
              disabled={isPending}
              onClick={() => requestTranscription(original.id)}
            >
              <Icon
                name={isPending ? "spinner" : "file alternate"}
                loading={isPending}
              />
              Request Transcription
            </Dropdown.Item>
          )}
          {original.call_direction === "INBOUND" && !original.contact_id && (
            <CallBackUnlinkedModal call={original} onSuccess={invalidateData} />
          )}
          {original.is_manual && (
            <DeleteCampaignTargetCallModal
              callId={original.id}
              fetchData={invalidateData}
              menuTrigger
            />
          )}
        </Dropdown.Menu>
      </CustomDropdown>
      {readable && (
        <ViewCallTranscriptDialog
          callId={original.id}
          open={transcriptOpen}
          onOpenChange={setTranscriptOpen}
        />
      )}
    </>
  );
}
